module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Score/assets/pain-f725f21d30b1a163a8871ecaf73a75a1.svg";